var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandexZenLogoIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.507 15.507C13.464 17.615 13.316 20.243 13.14 26c5.367 0 9.072-.019 10.985-1.876C25.981 22.211 26 18.33 26 13.14c-5.757.186-8.385.325-10.493 2.368M0 13.14c0 5.191.019 9.072 1.876 10.985C3.789 25.981 7.494 26 12.86 26c-.186-5.757-.325-8.385-2.368-10.493C8.385 13.464 5.757 13.316 0 13.14M12.86 0C7.504 0 3.79.019 1.877 1.876.019 3.789 0 7.67 0 12.86c5.757-.186 8.385-.325 10.493-2.368C12.536 8.385 12.684 5.757 12.86 0m2.646 10.493C13.464 8.385 13.316 5.757 13.14 0c5.367 0 9.072.019 10.985 1.876C25.981 3.789 26 7.67 26 12.86c-5.757-.186-8.385-.325-10.493-2.368",
    fill: "#ededf1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 13.14v-.28c-5.757-.185-8.385-.324-10.493-2.367C13.464 8.385 13.316 5.757 13.14 0h-.278c-.186 5.757-.325 8.385-2.368 10.493C8.385 12.536 5.757 12.684 0 12.86v.278c5.757.186 8.385.325 10.493 2.368 2.043 2.108 2.191 4.736 2.368 10.493h.278c.186-5.757.325-8.385 2.368-10.493 2.108-2.043 4.736-2.191 10.493-2.368",
    fill: "#181C32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexZenLogoIcon1);
export default __webpack_public_path__ + "static/media/yandex-zen-logo-icon-1.7c11990b7374bc23f812d279a0b34fd5.svg";
export { ForwardRef as ReactComponent };